import { getCurrentLocale } from "../../utils/util";
import { config } from "../../utils/constants";
import axios from "axios";


export const getTranslationByComponentId = (componentId, local) => {
  if (!local)
  {
    local = getCurrentLocale();
  }
  if (local) {
    local = local === "ar" || local === "ar_SA" ? "ar-SA" : "en-US";
  } else {
    local = "en-US";
  }
  // console.log("local in getTranslationByComponentId >> ", local);
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.translationUrl}get/${componentId}/${local}`
  };
  return axios.request(requestConfig);

};

export const fetchTranslationData = async (componentId, locale = null) => {
  try {
    // console.log(" componentId >>>> ", componentId);
    // console.log("locale>>>", locale);

    const language = window.document.cookie === "" ? "en-US" : null;
    const response = await getTranslationByComponentId(componentId, language); // Send referenceNo and dob as parameters
    // console.log(" response >>>> ", response)
    if (response.status === 200) {
      const tempTranslationMap = response.data.reduce((map, item) => {
        map[item?.key] = item?.translation; // Use the locale to get the translation value
        return map;
      }, {});
      // console.log("tempTranslationMap >>> ", tempTranslationMap);
      return tempTranslationMap;

    }
    return null;
  } catch (error) {
    console.error("Error fetching translation for:", componentId, error);
    return null;
  }
};